import 'css-chunksrc/client/common/portfolioAssignation/form/styles.scss';export default {
  "form": "_form_83lnr_1",
  "iconBox": "_iconBox_83lnr_9",
  "icon": "_icon_83lnr_9",
  "group": "_group_83lnr_21",
  "input": "_input_83lnr_25",
  "colorPicker": "_colorPicker_83lnr_35"
};